import { Helmet } from "react-helmet-async";

import { VerifierDetailsData } from "../../../../route/public/verifier/details/page/useDetails";

interface PublicVerifierDetailsMetaTagsProps {
  verifierDetailsData: VerifierDetailsData;
}

export const PublicVerifierDetailsMetaTags = ({
  verifierDetailsData,
}: PublicVerifierDetailsMetaTagsProps): JSX.Element | null => {
  return (
    <Helmet>
      <title>{verifierDetailsData?.displayName}</title>
      <meta name="title" content={verifierDetailsData?.displayName || undefined} />
      <meta name="description" content={verifierDetailsData.hero.subtitle || undefined} />
      <script type="application/ld+json">
        {JSON.stringify(
          {
            "@context": "https://schema.org",
            "@type": "Dataset",
            name: verifierDetailsData?.displayName,
            description: verifierDetailsData.hero.subtitle || undefined,
          },
          null,
          "\t"
        )}
      </script>
    </Helmet>
  );
};
